export function createPublicRssUrl(appOrigin: string, publicToken: string): string {
  return `${appOrigin.replace(/\/+$/, '')}/feeds/${publicToken}/rss.xml`;
}
